module.exports = __webpack_public_path__ + "static/media/archive-open-darkf9008036.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/practice_admin/images/archive-open-dark.svg
// module id = 1510
// module chunks = 0